import { Reveal, GoldButton } from "@/components/Reveal";
import { scrollToId } from "@/constants/site";

export const Pricing = () => (
  <section data-testid="pricing-section" className="border-y border-white/10 bg-slateDark px-5 py-16 sm:px-8 sm:py-20 lg:px-16">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
      <Reveal>
        <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-gold">A Gentle Starting Point</p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight text-zinc-50 sm:text-4xl">
          Selected Journeys From <span className="italic text-gold-gradient">₹9,999*</span>
        </h2>
        <p className="mt-4 max-w-lg text-sm font-light leading-relaxed text-zinc-400">
          A selection of curated journeys can start from ₹9,999, depending on destination, duration, dates,
          group size and inclusions.
        </p>
        <p className="mt-3 max-w-lg text-[11px] font-light leading-relaxed text-zinc-500">
          *Starting prices vary according to destination, duration, travel dates, group size and inclusions.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <GoldButton testId="pricing-plan-cta" onClick={() => scrollToId("plan")}>
          Plan My Journey
        </GoldButton>
      </Reveal>
    </div>
  </section>
);
